// extracted by mini-css-extract-plugin
export default {"seeMore":"styles_seeMore__rx5Uh"};